import actions from '@/vuex/modules/progressReport/actions'
import getters from '@/vuex/modules/progressReport/getters'
import mutations from '@/vuex/modules/progressReport/mutations'

const namespaced = true

const state = {
  middleLang: [],
  BPList: [],
  tableData: [],
  chartData: [],
  selectedIOId: 0,
  today: '',
}

const progressReport = {
  state: state,
  namespaced: namespaced,
  getters: getters,
  actions: actions,
  mutations: mutations,
}

export default progressReport
